import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

type Product = {
  id: string;
  name: string;
  image: string;
  price: string;
  rating: number;
  reviews: number;
  link: string;
};

export const getProducts = async (): Promise<Product[]> => {
  try {
    const querySnapshot = await getDocs(collection(db, "proudcts"));

    const products = querySnapshot.docs.map((doc) => {
      const data = doc.data();

      return {
        id: doc.id,
        name: data.name || "Default Name",
        image: data.image || "default-image.jpg",
        price: data.price || "0.00",
        rating: data.rating || 0,
        reviews: data.reviews || 0,
        link: data.link || "#",
      };
    });
    return products;
  } catch (error) {
    console.error("Error getting products:", error);
    return [];
  }
};
